import SvgIcon, { SvgIconProps } from "./SvgIcon";

const KayakIcon: React.FC<SvgIconProps> = ({ variant, ...props }) => {
  return (
    <SvgIcon {...props}>
      {variant == "outlined" ? (
        <>
          <g clipPath="url(#clip0_2736_51)">
            <path
              d="M6.414 6.414C6.78894 6.03894 6.99957 5.53033 6.99957 5C6.99957 4.46967 6.78894 3.96105 6.414 3.586L5 2.172L2.172 5L3.586 6.414C3.96105 6.78894 4.46967 6.99957 5 6.99957C5.53033 6.99957 6.03894 6.78894 6.414 6.414Z"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.5861 17.586C17.2111 17.9611 17.0005 18.4697 17.0005 19C17.0005 19.5303 17.2111 20.0389 17.5861 20.414L19.0001 21.828L21.8281 19L20.4141 17.586C20.039 17.2111 19.5304 17.0004 19.0001 17.0004C18.4697 17.0004 17.9611 17.2111 17.5861 17.586Z"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.5 6.5L17.5 17.5"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22 2.5C12.017 5.101 4.373 10.452 2 22C11.983 19.399 19.627 14.048 22 2.5Z"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.5 12.5L11.5 17.5"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.5 6.5L17.5 11.5"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2736_51">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </>
      ) : (
        <>
          <g clipPath="url(#clip0_2811_48)">
            <path
              d="M6.414 6.414C6.78894 6.03894 6.99957 5.53033 6.99957 5C6.99957 4.46967 6.78894 3.96105 6.414 3.586L5 2.172L2.172 5L3.586 6.414C3.96105 6.78894 4.46967 6.99957 5 6.99957C5.53033 6.99957 6.03894 6.78894 6.414 6.414Z"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.586 17.586C17.2111 17.9611 17.0004 18.4697 17.0004 19C17.0004 19.5303 17.2111 20.0389 17.586 20.414L19 21.828L21.828 19L20.414 17.586C20.0389 17.2111 19.5303 17.0004 19 17.0004C18.4697 17.0004 17.9611 17.2111 17.586 17.586Z"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <path
              d="M22 2.5C12.017 5.101 4.373 10.452 2 22C11.983 19.399 19.627 14.048 22 2.5Z"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.5 12.5L11.5 17.5"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.5 6.5L17.5 11.5"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 6L21 3H22L18.5 12L13 6Z"
              fill={props.stroke || "black"}
            />
            <path
              d="M11.0837 17.9994L3.12671 21.1118L2.12681 21.1259L5.49967 12.0775L11.0837 17.9994Z"
              fill={props.stroke || "black"}
            />
            <path
              d="M6.5 6.5L17.5 17.5"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2811_48">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </>
      )}
    </SvgIcon>
  );
};

export default KayakIcon;
